import palette from 'src/designSystem/variables/palette'
import styled from 'styled-components/macro'

export const NewMarkdownEditorWrapper = styled.div`
  .react-mde {
    border-radius: 20px;
    border: 1px solid ${palette.neutral[100]};
    overflow: hidden;

    .mde-header {
      display: flex;
      align-items: center;
      background: none;
      border-bottom: 1px solid ${palette.neutral[100]};
      font-size: 12px;
      padding: 8px 12px;

      .mde-tabs {
        gap: 4px;

        button {
          font-size: 12px;
          font-weight: 600;
          border-radius: 8px;
          padding: 4px 12px;
          color: ${palette.neutral[600]};

          &:first-child {
            padding: 8px 14px;
          }

          &.selected {
            border-radius: 8px;
            border-color: black;
          }
        }
      }

      .svg-icon {
        width: 0.85em;
        height: 0.85em;
      }

      ul.mde-header-group {
        border-left: none;
        padding: 6px 20px;
        gap: 40px;

        li.mde-header-item {
          margin: 0;

          button {
            height: 18px;
            padding: 2px;
            color: ${palette.neutral[600]};
          }
        }
      }
    }

    .mde-textarea-wrapper textarea {
      border: none;
      outline: none;
      resize: none;
      overflow-y: auto;

      &:focus-visible {
        outline: none;
      }
    }
  }
`
